module.exports = __webpack_public_path__ + "images/New_Format_GSE_Promo_Video_rev7_1080p.mp4";